module.exports = __webpack_public_path__ + "static/img/weather1.c08bc42.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/weather1.png
// module id = w3Sy
// module chunks = 0